/* eslint-disable unicorn/filename-case -- TODO rename later */
import { ChangeEvent, memo } from "react";

interface TextAreaProps {
  ariaLabel?: string;
  dataTestId?: string;
  disabled?: boolean;
  isError?: boolean;
  placeholder?: string;
  value?: string;
  onChange?: (_value: string) => void;
}

/**
 * @deprecated Use `@istari-frontend/ui` instead.
 *
 * @example
 * import { Textarea } from "@istari-frontend/ui"
 */
const TextArea = memo(
  ({
    ariaLabel,
    dataTestId,
    disabled = false,
    isError = false,
    placeholder = "",
    value = "",
    onChange,
  }: TextAreaProps) => {
    const borderColor = isError ? "border-red-400" : "border-gray-300";
    const bgColor = disabled ? "bg-gray-50" : "bg-white";
    const textColor = disabled ? "text-gray-400" : "text-gray-600";
    const focusStyle = !disabled
      ? "shadow-[inset_0_1px_0_rgba(0,0,0,0.04)] focus-within:shadow-[inset_0_1px_0_rgba(0,0,0,0.06)]"
      : "";
    const ringStyle = !disabled
      ? isError
        ? "focus:ring-2 focus:ring-inset focus:ring-red-100"
        : "focus:ring-2 focus:ring-inset focus:ring-gray-100"
      : "";

    return (
      <div className="mt-1">
        <textarea
          aria-label={ariaLabel}
          className={`min-h-12 w-full max-w-full rounded border px-2.5 py-1.5 font-sans text-sm transition-all duration-150 hover:border-gray-400 focus:border-gray-400 focus:outline-none disabled:hover:border-gray-300 ${borderColor} ${bgColor} ${textColor} ${focusStyle} ${ringStyle} ${disabled ? "opacity-50" : ""}`}
          data-testid={dataTestId}
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => onChange?.(e.target.value)}
        />
      </div>
    );
  },
);

export default TextArea;
